import { LoginComponent } from "./login/login.component";
import {AuthComponent} from "./auth/auth.component";
export { DashboardComponent } from "./dashboard/dashboard.component";

export const Templates = {
  Login: LoginComponent,
  Auth: AuthComponent,
};
